<template>
  <div class="container center" style="text-align: center;">

    <div v-if="showLoader">
      <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
    </div>

    <div v-if="!showLoader">
      <div v-if="data.length === 0">
        <p style="font-weight: bold; font-size: larger" v-if="language === 'en'">Oops, we are sorry. This link has
          expired, please <a :href="applyLink">apply
            again </a>. If this message seems
          to be an error please let us know. Send us an email to {{ toEmail }} to help you better</p>
        <p style="font-weight: bold; font-size: larger" v-if="language === 'fr'">Oups, nous sommes désolés. Ce lien a
          expiré, veuillez
          <a :href="applyLink"> réappliquer</a>. Si ce message
          semble être
          une erreur, veuillez nous en informer. Envoyez-nous un courriel à {{ toEmail }} pour mieux vous aider.
        </p>
      </div>

      <div v-if="data.length > 0" class="centered-content">

        <div v-if="hasUnsignedContracts" style="margin-bottom: 20px;">
          <p style="font-weight: bold; font-size: larger" v-if="language === 'en'">You have been
            pre-approved for a loan of ${{ creditLimit }}. <br> </p>

          <p style="font-weight: bold; font-size: larger" v-if="language === 'fr'">Vous avez été pré-approuvé
            pour un prêt de {{ creditLimit }}$</p>
        </div>

        <div v-if="data[0].loan_status === 'Signed'" class="row" style="margin-top: 20px;">
          <div v-for="(item, index) in data" :key="index" class="col-12" style="margin-bottom: 20px;">
            <div v-if="item.loan_status === 'Signed'">
              <p class="sign" style="font-weight: bold; font-size: 32px; margin: 0;" v-if="language === 'en'">Your
                contract has already been signed!
                <br>No need for any additional actions on your part.
                <br>Check your email to receive your funds.
              </p>
              <p class="sign" style="font-weight: bold; font-size: 32px; margin: 0;" v-if="language === 'fr'">Votre
                contrat a déjà été signé !
                <br>Aucune action supplémentaire n'est requise de votre part.
                <br>Vérifiez votre courriel pour recevoir vos fonds.
              </p>
            </div>
          </div>
        </div>

        <b-spinner v-if="loadingContract" style="width: 3rem; height: 3rem;" label="Spinning"></b-spinner>

      </div>
    </div>
  </div>
</template>

<script>
const axios = require('axios');

export default {
  data() {
    return {
      loading: true,
      loadingContract: false,
      data: [],
      creditLimit: '',
      nameOfEmployer: '',
      language: 'en',
      storefront: '',
      toEmail: '',
      applyLink: '',
      showLoader: true,
    }
  },
  computed: {
    hasUnsignedContracts() {
      return this.data.some(item => item.loan_status !== 'Signed');
    }
  },
  methods: {
    makeToast(variant = null, title = '', content = '') {
      this.$bvToast.toast(content, {
        title: title,
        variant: variant,
        solid: true
      })
    },

    async getContractLink(item) {
      try {
        const contractPdfLink = item.contract_pdf_link;
        if (!contractPdfLink) {
          this.makeToast('warning', 'Contract not available', 'Contract is not available for this loan');
          return;
        }
        this.loadingContract = true;
        const { clientUrl } = (await axios.post(
          `${process.env.VUE_APP_GAGLIANO_BASE_URL}/contracts`,
          { key: contractPdfLink },
          {
            headers: {
              "token": this.$route.query.token
            }
          }
        )).data;
        window.open(clientUrl, '_blank');
      } catch (error) {
        console.error('Error getting contract link', error);
        this.makeToast('danger', 'Please try again later', 'Error getting the contract link.');
      } finally {
        this.loadingContract = false;
      }
    },

    async dataList() {
      this.showLoader = true;
      const response = await axios.get(
        `${process.env.VUE_APP_BASE_URL}/approvedLoanOptions?token=${this.$route.query.token}`
      );
      this.showLoader = false;
      if (response && response.data) {
        this.loading = false;
        this.data = response.data.value;
        const company = response.data.companyInfo;
        this.storefront = company.name;
        this.toEmail = company.reply_to_email;
        this.creditLimit = Math.max(...this.data.map(o => o.credit_limit));
        this.nameOfEmployer = company.name;
        this.language = company.language;
        this.applyLink = company.apply_link;
        this.$root.$emit('on-set-logo', {
          logo: company.logo,
          contactUs: company.contact_us_link,
          homepage_link: company.homepage_link,
          language: this.language
        });

        this.submit();
      }
    },

    async submit() {
      const contracts = [];
      const offers = [];

      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].loan_status !== 'Signed') {
          contracts.push(this.data[i].id);
          offers.push(this.data[i].credit_limit);
        }
      }

      if (contracts.length > 0) {
        this.$router.push({
          path: `/contract/${contracts[0]}`,
          query: {
            token: this.$route.query.token,
            language: this.language,
            storefront: this.storefront,
            contracts: contracts.join(),
            offers: offers.join()
          }
        });
      } else {
        this.makeToast('info', 'All contracts signed',
          this.language === 'en'
            ? 'All your contracts have already been signed.'
            : 'Tous vos contrats ont déjà été signés.');
      }
    },
  },

  async mounted() {
    this.dataList();
  }
}
</script>

<style scoped>
.centered-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
}

.nextBtn {
  margin: 10px;
}

.btn-enabled {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.amount_para {
  margin: 0;
  font-weight: bold;
  font-size: 24px;
}

.sign {
  color: green !important;
  text-decoration: none;
}
</style>
